import { canAccessRouteWithSnapshot } from "../../services/routeAccess";

export const buildCuadrillasCapabilities = (snapshot = null) => {
	const session = snapshot?.session || {};
	const rol = Number(session?.rol || 0);
	const idCliente = Number(session?.idCliente || 0);
	const idClienteG = Number(session?.idClienteG || 0);
	const rolNombre = String(session?.rolNombre || "").trim().toLowerCase();
	const isClientScopedUser =
		rol !== 980 &&
		(rol === 990 || rolNombre === "cabo cliente" || idCliente > 0 || idClienteG > 0);
	const canExportPartesGrupo = canAccessRouteWithSnapshot(
		"/cuadrillas/exportar",
		snapshot || undefined
	);
	const canManageRecolectorChecks = [982, 986].includes(rol);

	return {
		isClientScopedUser,
		canExportExcel: canExportPartesGrupo,
		canManageRecolectorChecks,
		canExportDetalleConChecks: canExportPartesGrupo,
		canSelectPartes: canExportPartesGrupo,
		canEditEstado: !isClientScopedUser,
		canUploadAvatar: !isClientScopedUser,
		canDeleteAvatarLuxand:
			Number(session?.rol || 0) === 986 ||
			canAccessRouteWithSnapshot("/admin", snapshot || undefined),
		canHideFichaje: Number(session?.rol || 0) === 986,
		canUsePhotoCheck: !isClientScopedUser,
		canOpenOperativos: canAccessRouteWithSnapshot("/cuadrillas/operativos", snapshot || undefined),
	};
};
